import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import useSanitizedHtml from 'hooks/useSanitizedHtml';

const ReadMore = ({ description, mobileLength, desktopLength, style }) => {
  const [readMore, setReadMore] = useState(true);
  const toggleReadMore = () => setReadMore(prev => !prev);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const textLength = isMobile ? mobileLength : desktopLength;
  const content =
    readMore && description.length > textLength ? description.slice(0, textLength) : description;

  const sanitizedHtml = useSanitizedHtml(content.replaceAll('\n', '<br />'));

  return (
    <>
      <p
        dangerouslySetInnerHTML={{
          __html: sanitizedHtml,
        }}
        style={style || {}}
      />

      {description.length > textLength && (
        <strong
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            toggleReadMore();
          }}
          className={clsx('color-main', 'cursor-pointer')}
          style={style || {}}
        >
          {readMore ? ' ...read more' : ' show less'}
        </strong>
      )}
    </>
  );
};

ReadMore.propTypes = {
  description: PropTypes.string.isRequired,
  mobileLength: PropTypes.number,
  desktopLength: PropTypes.number,
};

ReadMore.defaultProps = {
  mobileLength: 300,
  desktopLength: 500,
};

export default ReadMore;
